import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { TextField, SelectField } from '../../components'
import { Alert, Button, Col, Row, SubmitRow } from '../../elements'

import validate from './validate'

class ZoneForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }
    state = {
        selectedClient: ""
    }

    changeSiteHandler = (values) => {
        this.setState({ selectedClient: values })
    }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients, sites, initialValues } = this.props
        const clientIdDisabled = Boolean(get(initialValues, 'clientId'))
        const siteIdDisabled = Boolean(get(initialValues, 'siteId'))
        const zoneIdDisabled = Boolean(get(initialValues, 'zoneId'))
        let clientIds = null
        let selectedSiteIds = null
        let siteIds = null
        if(clients){
            clientIds = clients.map(client => client.clientId);
            selectedSiteIds = sites.filter(site => site.clientId == this.state.selectedClient);
            siteIds = selectedSiteIds.map(site => site.siteId)
        } else if (initialValues) {
            clientIds = [initialValues.clientId]
            siteIds = [initialValues.siteId]
        }

        if(clientIds == null){
            clientIds = ['']
            siteIds = ['']
        }

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Field
                    name="clientId"
                    label="Client Id"
                    options={clientIds}
                    disabled={clientIdDisabled}
                    component={SelectField}
                    onChange={this.changeSiteHandler}
                />
                <Field
                    name="siteId"
                    label="Site Id"
                    options={siteIds}
                    disabled={siteIdDisabled}
                    component={SelectField}
                />
                <Field
                    name="zoneId"
                    label="Zone Id"
                    disabled={zoneIdDisabled}
                    component={TextField}
                />
                <Field
                    name="name"
                    label="Name"
                    disabled={isSubmiting}
                    component={TextField}
                />
                <Field
                    name="description"
                    label="Description"
                    disabled={isSubmiting}
                    component={TextField}
                />
                <SubmitRow>
                    <Row type="flex" gutter={20}>
                        <Col>
                            <Button htmlType="submit" type="primary" wide>
                                {siteIdDisabled ? 'Save' : 'Create'}
                            </Button>
                        </Col>
                    </Row>
                </SubmitRow>
            </form>
        )
    }
}

export default reduxForm({
    form: 'zone-form',
    validate,
})(ZoneForm)



// WEBPACK FOOTER //
// ./src/smart-components/zone-form/index.js